import { Component, Input, OnChanges } from '@angular/core';
import { PortfolioType } from '@ddt-web/config';
import { CellData, CellUtil, ComponentData } from '@ddt-web/data-service';


@Component({
	selector: 'ac-pdf-portfolios-header',
	templateUrl: './pdf-portfolios-header.component.html',
	styleUrls: ['./pdf-portfolios-header.component.scss']
})
export class PdfPortfoliosHeaderComponent implements OnChanges {

	constructor() {
		this.PORTFOLIO_IMAGES['CUSTOMIZED_MODEL_PORTFOLIO'] = '/icon-library-portfolio-with-base.svg';
		this.PORTFOLIO_IMAGES[PortfolioType.PORTFOLIO] = '/icon-library-portfolio.svg';
		this.PORTFOLIO_IMAGES[PortfolioType.MODEL] = '/icon-library-blk-model.svg';
	}

	@Input() public data: ComponentData;
	public portfolios: any[] = [];

	public readonly PORTFOLIO_IMAGES = {};
	public portfolioImageMap: Map<string, string> = new Map<string, string>();
	public columnClass: string;

	public ngOnChanges(): void {
		if (this.data && !this.data.error) {
			const portfolioTypes = CellUtil.getCellsById<CellData>(this.data.portfolioData, 'portfolioType');
			const portfolioNames = CellUtil.getCellsById<CellData>(this.data.portfolioData, 'name');
			portfolioNames
				.filter(cellData => cellData.formattedValue)
				.forEach((name, index) => this.portfolios.push({ type: portfolioTypes[index].formattedValue, name: name.formattedValue }));

			this.portfolios.forEach(portfolio => {
				this.portfolioImageMap.set(portfolio.name, this.PORTFOLIO_IMAGES[portfolio.type]);
			});

			this.assignColumnClasses(this.portfolios.length);
		}
	}

	public assignColumnClasses(index: number): void {
		switch (index) {
			case 1:
				this.columnClass = 'col-24';
				break;
			case 2:
				this.columnClass = 'col-10';
				break;
			case 3:
			default:
				this.columnClass = 'col-7';
		}
	}
}
